@if (initialized) {
    <div class="grid h-full">

        <div class="md:col-3 col-12 transition-col" [class.hidden-filter]="hideFilters">
            <div class="surface-0 shadow-1 p-3 border-round h-full" *ngIf="!hideFilters">
                <div class="flex justify-content-between align-items-center border-bottom-1 border-200 pb-2">
                    <h4 class="m-0">Creditor Bank Account Documents</h4>
                    <!--                    <p-button pTooltip="Create Import" icon="pi pi-plus-circle text-xl" styleClass="p-button-text"-->
                    <!--                              (click)="handleCreateImport()"></p-button>-->
                </div>

                <div class="w-full mt-3">

                    <!-- All Groups -->
                    <div class="mt-2">
                        <p-panel
                                class="panel-blank group-panel-section"
                                [iconPos]="'end'"
                                (collapsedChange)="togglePanel($event)">

                            @if (dto) {


                                <bm-creditor-bank-account-basic-details
                                        [creditorBankAccountDto]="dto">
                                </bm-creditor-bank-account-basic-details>
                            }
                        </p-panel>

                    </div>

                </div>
            </div>
        </div>


        <div class="col-12 smooth-transition" [ngClass]="hideFilters ? 'md:col-12' : 'md:col-9'">


            <div class="layout-wrapper">
                <div class="main-panel" [ngClass]="{ 'expanded': isLeftExpanded }">
                    <div class="flex gap-3 justify-content-between align-items-center mb-2 surface-0 shadow-1 p-2">
                        <div class="flex gap-3 overflow-auto align-items-center">
                            <p-button styleClass="p-button-text text-600" (click)="hideFilterSection()"
                                      icon="pi pi-bars"></p-button>
                        </div>
                    </div>

                    @if (dto) {

                        <p-tabs [(value)]="activeIndex">
                            <p-tablist>
                                <p-tab [value]="0">Transactions</p-tab>
                                <p-tab [value]="1">Imports</p-tab>
                            </p-tablist>
                            <p-tabpanels>
                            <p-tabpanel [value]="0">
                                @if (activeIndex == 0) {
                                    <bm-creditor-bank-account-transactions-component
                                            [creditorBankAccountDto]="dto"
                                            (onObjectSelect)="handleObjectSelect($event)">
                                    </bm-creditor-bank-account-transactions-component>
                                }
                            </p-tabpanel>
                            <p-tabpanel [value]="1">
                                @if (activeIndex == 1) {
                                    <bm-creditor-bank-account-import-component
                                            [creditorBankAccountDto]="dto"
                                            (onObjectSelect)="handleObjectSelect($event)">
                                    </bm-creditor-bank-account-import-component>
                                }
                            </p-tabpanel>
                            </p-tabpanels>
                        </p-tabs>
                    }
                </div>
                <div class="right-panel" [ngClass]="{ 'hidden': isLeftExpanded }">

                    @if (selectedObject) {
                    <mvs-object [objectType]="selectedObject.objectType" [objectId]="selectedObject.objectId"></mvs-object>
                    }

                </div>
            </div>


        </div>
    </div>
}